// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2cdHm","label":"Section_label__2w2f-","contentWrap":"Section_contentWrap__mU0-D","footer":"Section_footer__93S8C","footerInner":"Section_footerInner__1ZKNY"};